__webpack_require__.p = "/yahtzee/";